import { openBlock as s, createElementBlock as t, createElementVNode as n } from "vue";
import { _ as l } from "../_plugin-vue_export-helper-dad06003.js";
const a = {
  name: "rLoading"
}, c = { class: "r-loading" }, _ = /* @__PURE__ */ n(
  "span",
  null,
  null,
  -1
  /* HOISTED */
), i = /* @__PURE__ */ n(
  "span",
  null,
  null,
  -1
  /* HOISTED */
), d = /* @__PURE__ */ n(
  "span",
  null,
  null,
  -1
  /* HOISTED */
), r = /* @__PURE__ */ n(
  "span",
  null,
  null,
  -1
  /* HOISTED */
), u = [
  _,
  i,
  d,
  r
];
function p(e, m, f, h, g, v) {
  return s(), t("div", c, u);
}
const o = /* @__PURE__ */ l(a, [["render", p], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/loading/loading.vue"]]);
o.install = function(e) {
  e.component(o.name, o);
};
export {
  o as default
};
